import React, { useState, useEffect } from "react";
import { Layout, Card, Button, Row, Col, Typography } from "antd";
import { FiUsers, FiClock, FiCalendar } from "react-icons/fi";
import Sidebar from "./Sidebar";
import HeaderBar from "./HeaderBar";
import Footer from "./Footer";
import { useNavigate } from "react-router-dom";

const { Content, Sider } = Layout;
const { Title } = Typography;

function Dashboard() {
  const navigate = useNavigate();
  const [collapsed, setCollapsed] = useState(false);
  const [user, setUser] = useState(null);

  const cardStyles = [
    { background: "linear-gradient(135deg, #FF6B6B, #FF8787)", icon: <FiUsers /> },
    { background: "linear-gradient(135deg, #1E90FF, #4DABF7)", icon: <FiClock /> },
    { background: "linear-gradient(135deg, #4ADE80, #22C55E)", icon: <FiCalendar /> },
  ];

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if (storedUser) {
      setUser(JSON.parse(storedUser));
    } else {
      navigate("/login");
    }
  }, [navigate]);

  if (!user) return null;

  return (
    <Layout
      style={{
        minHeight: "100vh",
        fontFamily: "Poppins, sans-serif",
      }}
    >
      {/* Sidebar – collapses fully on mobile */}
      <Sider
        collapsible
        collapsed={collapsed}
        onCollapse={setCollapsed}
        breakpoint="md"
        collapsedWidth="0"
        width={220}
        style={{ background: "#fff" }}
      >
        <Sidebar collapsed={collapsed} user={user} />
      </Sider>

      <Layout>
        <HeaderBar title="Dashboard" />

        {/* Responsive content */}
        <Content
          style={{
            padding: "20px 15px",
            background: "#f5f6fa",
          }}
        >
          <Row
            gutter={[20, 20]}
            justify="center"
            style={{
              maxWidth: 1200,
              margin: "0 auto",
              width: "100%",
            }}
          >
            {cardStyles.map((card, index) => {
              const titles = ["View User Details", "Time Slots", "Total Meetings"];
              const buttons = ["View Details", "Manage Slots", "Manage Meetings"];
              const routes = ["/user", "/slots", "/meetings"];

              return (
                <Col xs={24} sm={12} md={8} key={index}>
                  <Card
                    hoverable
                    style={{
                      background: card.background,
                      borderRadius: 12,
                      textAlign: "center",
                      padding: "25px 15px",
                      minHeight: 240,
                      boxShadow: "0 8px 20px rgba(0,0,0,0.1)",
                      transition: "transform 0.3s",
                    }}
                    onMouseEnter={(e) => (e.currentTarget.style.transform = "translateY(-5px)")}
                    onMouseLeave={(e) => (e.currentTarget.style.transform = "translateY(0)")}
                  >
                    <div style={{ display: "flex", justifyContent: "center" }}>
                      <div
                        style={{
                          fontSize: "52px",
                          color: "#fff",
                          marginBottom: 16,
                          transition: "0.3s",
                        }}
                      >
                        {card.icon}
                      </div>
                    </div>

                    <Title level={4} style={{ color: "#fff", marginTop: 0 }}>
                      {titles[index]}
                    </Title>

                    <Button
                      block
                      style={{
                        background: "#fff",
                        color: "#000",
                        fontWeight: "bold",
                        border: "none",
                        marginTop: 10,
                      }}
                      onClick={() => navigate(routes[index])}
                    >
                      {buttons[index]}
                    </Button>
                  </Card>
                </Col>
              );
            })}
          </Row>
        </Content>

        <Footer user={user} />
      </Layout>
    </Layout>
  );
}

export default Dashboard;
